import { DashboardCreate } from "../models/DashboardCreate";
import axiosApi from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";

export default (dashboard: DashboardCreate) =>
  axiosApi.post(BackendServices.DASHBOARD_SERVICE.DASHBOARD, dashboard);
